import * as React from "react";
const IconTextAlignCenterCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M10.9 6.7h42.2c.6 0 1-.4 1-1s-.4-1-1-1H10.9c-.6 0-1 .4-1 1s.5 1 1 1M7 24.2h50c.6 0 1-.4 1-1s-.4-1-1-1H7c-.6 0-1 .4-1 1s.4 1 1 1M14.9 39.8c-.6 0-1 .4-1 1s.4 1 1 1h34.3c.6 0 1-.4 1-1s-.4-1-1-1zM61 57.3H3c-.6 0-1 .4-1 1s.4 1 1 1h58c.6 0 1-.4 1-1s-.4-1-1-1" />
  </svg>
);
export default IconTextAlignCenterCopy;
